import React from 'react'
import { Provider } from 'react-redux'
import createStore from '~gatsby-theme-autonomy/redux/store'
import { usePreloadedState } from '~gatsby-theme-autonomy/hooks/context/use-preloaded-state'

const ReduxProvider = ({ children }) => {
  // hydrate the Redux store with data from our GraphQL queries.
  const preloadedState = usePreloadedState()

  const store = createStore(undefined, preloadedState)

  return <Provider store={store}>{children}</Provider>
}

export default ReduxProvider
